import ICPemasukan2 from 'assets/icons/pemasukan-2.svg'
import ICPengeluaran2 from 'assets/icons/pengeluaran-2.svg'
import { P } from 'components'
import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import { Can } from 'context/Acl'
import moment from 'moment-timezone'
import { ArrowLeft, Edit2, Trash2 } from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, CardBody, Col, Row } from 'reactstrap'
import { formatDatePMBV2 } from 'utils/formatDate'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import {
  ARUS_KAS_FORM,
  HISTORY_ARUS_KAS,
  URL_DETAIL_TRANSACTION,
} from 'utils/pathUrl'
import { BUSINESS_BOOKKEEPING, BUSINESS_BOOKKEEPING_COMPANY, MANAGE } from 'utils/subjectActions'
import { useLazyGetArusKasQuery, useLazyGetArusKasPersonalQuery } from './cashFlowApiSlice'
import { toggleModalDelete, toggleSidebarCashflow } from './cashFlowSlice'
import { formatNotes } from './downloadHistory'
import ModalDelete from './ModalDelete'
import { useEffect, useState } from 'react'

const DetailCashFlowById = () => {
  const {
    isOpenModalDelete,
    isOpenSidebarCashFlow,
    isOpenBanner,
    tag,
    filters,
  } = useSelector((s) => s.cashflow)
  const { row: initialRow } = useLocation().state
  const [row, setRow] = useState(initialRow)

  const { selectedDate, selectedFilter } = filters

  const [getArusKas, res] = useLazyGetArusKasQuery()
  const [getArusKasPersonal, resPersonal] = useLazyGetArusKasPersonalQuery()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const isPersonal = window.location.search.includes('personal=true')

  useEffect(() => {
    const fetchRow = async () => {
      try {
        const result = await (isPersonal ? getArusKasPersonal : getArusKas)({
          startdate: moment(selectedDate[0]).format('YYYY-MM-DD'),
          enddate: moment(selectedDate[1])
            .local()
            .add(1, 'days')
            .format('YYYY-MM-DD'),
          filter: selectedFilter?.value,
          page: tag?.page,
          size: tag?.size,
        }).unwrap()

        const updatedRow = result?.data?.content?.find((item) => item.id === row.id)
        if (updatedRow) {
          setRow(updatedRow)
        }
      } catch (error) {
        console.error("Failed to fetch updated row", error)
      }
    }
    fetchRow()
  }, [])

  const handleFinishedDelete = async () => {
    await getArusKas({
      startdate: moment(selectedDate[0]).format('YYYY-MM-DD'),
      enddate: moment(selectedDate[1])
        .local()
        .add(1, 'days')
        .format('YYYY-MM-DD'),
      filter: selectedFilter?.value,
      page: tag?.page,
      size: tag?.size,
    })
    navigate(HISTORY_ARUS_KAS)
  }

  return (
    <div className="w-100 px-4">
      <ModalDelete
        isOpen={isOpenModalDelete}
        toggle={() => dispatch(toggleModalDelete())}
        row={row}
        handleFinishedDelete={handleFinishedDelete}
        isPersonal={isPersonal}
      />

      <div className="mt-4">
        <BreadCrumbs
          breadCrumbParent2="Daftar Riwayat Arus Kas"
          breadCrumbParent2Link={HISTORY_ARUS_KAS}
          breadCrumbActive="Detail Arus Kas"
        />
      </div>

      <div>
        <div className="row align-items-center py-3">
          <div className="col-12 col-md-6 d-flex align-items-center mb-2 mb-md-0">
            <ArrowLeft
              size={20}
              className="me-2"
              style={{ cursor: 'pointer' }}
              onClick={() => navigate(-1)}
            />
            <h6 className="fw-bold mb-0">Detail Arus Kas</h6>
          </div>

          <div className="col-12 col-md-6 d-flex justify-content-md-end gap-2 flex-column flex-md-row">
            <Can I={MANAGE} this={isPersonal ? BUSINESS_BOOKKEEPING : BUSINESS_BOOKKEEPING_COMPANY}>
              {row?.manual && (
                <>
                  <CustomButton
                    onClick={() => dispatch(toggleModalDelete())}
                    color="danger"
                    outline
                  >
                    <div className="flex-centered gap-2">
                      <Trash2 size={16} /> Hapus Catatan
                    </div>
                  </CustomButton>
                  <CustomButton
                    onClick={() => {
                      navigate(ARUS_KAS_FORM, {
                        state: {
                          income:
                            row?.incomeorexpense === 'income' ? true : false,
                          expense:
                            row?.incomeorexpense === 'expense' ? true : false,
                          ...row,
                          isEdit: true,
                          isPersonal: isPersonal
                        },
                      })
                      dispatch(toggleSidebarCashflow())
                    }}
                    color="primary"
                  >
                    <div className="flex-centered gap-2">
                      <Edit2 size={16} /> Ubah Catatan
                    </div>
                  </CustomButton>
                </>
              )}
            </Can>
          </div>
        </div>
      </div>

      {/* LEFT AND RIGHT COLUMN */}
      <Row>
        {/* LEFT COLUMN  */}
        <Col md="5">
          <Card className="shadow-sm border-0 mb-3">
            <CardBody>
              <h6 className="fw-semibold mb-3">Informasi</h6>
              {(row?.offlineID?.includes('penjualanpasarbaru') ||
                row?.offlineID?.includes('pembelianpasarbaru')) && (
                  <Row className="mb-3">
                    <Col xs="6" className="fw-light text-sm">
                      Referensi transaksi
                    </Col>
                    <Col xs="6" className="fw-semibold text-sm">
                      <span
                        className="text-primary pointer"
                        onClick={() => {
                          navigate(
                            `${URL_DETAIL_TRANSACTION}/${row.offlineID.split('-').pop()}?type=${row.offlineID.includes('penjualanpasarbaru')
                              ? 'sell'
                              : 'buy'
                            }`,
                          )
                          // toggle()
                        }}
                      >
                        {row?.extradata?.poNumber}
                      </span>
                    </Col>
                  </Row>
                )}
              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Kategori
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <img
                      height={24}
                      width={24}
                      src={
                        row?.incomeorexpense === 'income'
                          ? ICPemasukan2
                          : ICPengeluaran2
                      }
                      alt={
                        row?.incomeorexpense === 'income'
                          ? 'Pemasukan'
                          : 'Pengeluaran'
                      }
                    />
                    <span>{row?.label}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <div
                      className={`badge rounded-pill ${row?.subType.toLowerCase() === 'sistem transaksi' ? 'bg-warning-50 text-warning-700' : row?.subType.toLowerCase() === 'catat manual' ? 'bg-gray-100 text-gray-700' : 'bg-danger-50 text-danger-700'}`}
                    >
                      {row?.subType}
                    </div>
                  </div>
                </Col>
              </Row>
              <Row className="mb-3">
                <Col xs="6" className="fw-light text-sm">
                  Tanggal
                </Col>
                <Col xs="6" className="fw-semibold text-sm">
                  {formatDatePMBV2(
                    `${row?.createddate + ' ' + row?.createdhour}`,
                  )}
                </Col>
              </Row>
              {row?.extradata?.items && (
                <Row className="mb-3">
                  <Col xs="6" className="fw-light text-sm">
                    {row?.incomeorexpense === 'income' ? 'Pembeli' : 'Penjual'}
                  </Col>
                  <Col xs="6" className="fw-semibold text-sm">
                    {row?.extradata?.picname}
                  </Col>
                </Row>
              )}

              {!row?.extradata?.items && (
                <Row className="mb-3">
                  <Col xs="6" className="fw-light text-sm">
                    Jumlah uang
                  </Col>
                  <Col xs="6" className="fw-semibold text-sm">
                    Rp{newFormatThousandSeparator(row?.amount ?? 0)}
                  </Col>
                </Row>
              )}
            </CardBody>
          </Card>
        </Col>

        {/* RIGHT COLUMN */}
        <Col md="7">
          <Card
            className="shadow-sm border-0 mb-3"
            style={{
              minHeight:
                row?.offlineID?.includes('penjualanpasarbaru') ||
                  row?.offlineID?.includes('pembelianpasarbaru')
                  ? '244px'
                  : '207px',
            }}
          >
            <CardBody>
              <div className="d-flex justify-content-between align-items-center">
                <div className="mb-3">
                  <P className="mb-2" bold>
                    Catatan
                  </P>
                  <span
                    className="truncate text-wrap"
                    style={{ whiteSpace: 'pre-line' }}
                  >
                    {row?.notes
                      ? formatNotes(row?.notes)
                      : 'Tidak ada catatan'}
                  </span>
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </div>
  )
}

export default DetailCashFlowById
